module.exports = __webpack_public_path__ + "ffb3d3c73880f489b0a6bd9b34b2203a.mp4";